import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Home from '@/pages/Home';
import About from '@/pages/About';
import Serve from '@/pages/Serve';
import Tool from '@/pages/Tool';
import SchemeCustomization from '@/pages/SchemeCustomization';
import FurnitureIndustrySolutions from '@/pages/FurnitureIndustrySolutions';
import VacuumRobotSolutions from '@/pages/VacuumRobotSolutions';
import BirdFeederSolutions from '@/pages/BirdFeederSolutions';
import PoolCleanerSolutions from '@/pages/PoolCleanerSolutions';
import RobotMowerSolutions from '@/pages/RobotMowerSolutions';
import EmbodiedRobotSolutions from '@/pages/EmbodiedRobotSolutions';
import CommercialRobotSolutions from '@/pages/CommercialRobotSolutions';
import AiRecorderSolutions from '@/pages/AiRecorderSolutions';
import AiGlassesSolutions from '@/pages/AiGlassesSolutions';
import WearableSolutions from '@/pages/WearableSolutions';
import Printer3dSolutions from '@/pages/Printer3dSolutions';
import LaserCutterSolutions from '@/pages/LaserCutterSolutions';
import EbikeIndustrySolutions from '@/pages/EbikeIndustrySolutions';
import ScooterSolutions from '@/pages/ScooterSolutions';
import DesktopCncSolutions from '@/pages/DesktopCncSolutions';
import ElderlyMobilitySolutions from '@/pages/ElderlyMobilitySolutions';
import SecurityCameraSolutions from '@/pages/SecurityCameraSolutions';
import TrailCameraSolutions from '@/pages/TrailCameraSolutions';
import WaterPurifierSolutions from '@/pages/WaterPurifierSolutions';
import IceMakerSolutions from '@/pages/IceMakerSolutions';
import FitnessGymSolutions from '@/pages/FitnessGymSolutions';
import PetFeederSolutions from '@/pages/PetFeederSolutions';
import OutdoorTvSolutions from '@/pages/OutdoorTvSolutions';
import PortableScreenSolutions from '@/pages/PortableScreenSolutions';
import SolarBessSolutions from '@/pages/SolarBessSolutions';
import HomeStorageSolutions from '@/pages/HomeStorageSolutions';
import PortablePowerSolutions from '@/pages/PortablePowerSolutions';
import ChargingPileSolutions from '@/pages/ChargingPileSolutions';
import IndustrySolutionPlaceholder from '@/pages/IndustrySolutionPlaceholder';
import { industrySolutionPaths } from '@/config/solutionPageMeta';
import { useEffect } from 'react';

const industrySolutionPlaceholderExclude = new Set([
  '/solutions/security/bird-feeder',
  '/solutions/robot/pool-cleaner',
  '/solutions/robot/mower',
  '/solutions/robot/embodied',
  '/solutions/robot/commercial',
  '/solutions/ai-hardware/recorder',
  '/solutions/ai-hardware/ai-glasses',
  '/solutions/ai-hardware/wearable',
  '/solutions/diy-tools/3d-printer',
  '/solutions/diy-tools/laser',
  '/solutions/diy-tools/cnc',
  '/solutions/mobility/scooter',
  '/solutions/mobility/elderly',
  '/solutions/security/ipc',
  '/solutions/security/hunting-camera',
  '/solutions/appliances/water-purifier',
  '/solutions/appliances/ice-maker',
  '/solutions/fitness/speediance',
  '/solutions/pet/smart-life',
  '/solutions/display/outdoor',
  '/solutions/display/portable-screen',
  '/solutions/new-energy/solar-storage',
  '/solutions/new-energy/home-storage',
  '/solutions/new-energy/portable',
  '/solutions/new-energy/charging-pile',
]);

export default function RoutesConfig({ currentLang }: { currentLang: string }) {
  function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    }, [pathname]);
    return null;
  }

  return (
    <main key={currentLang}>
      <ScrollToTop />
      <Routes>
        {/* 首页 */}
        <Route path="/" element={<Home />} />
        {/* 关于我们 */}
        <Route path="/about" element={<About />} />
        {/* 服务内容 */}
        <Route path="/serve" element={<Serve />} />
        {/* 工具支持 */}
        <Route path="/tool" element={<Tool />} />
        {/* 家具行业解决方案 */}
        <Route path="/furniture-industry-solutions" element={<FurnitureIndustrySolutions />} />
        <Route path="/solutions/robot/vacuum" element={<VacuumRobotSolutions />} />
        <Route path="/solutions/robot/pool-cleaner" element={<PoolCleanerSolutions />} />
        <Route path="/solutions/robot/mower" element={<RobotMowerSolutions />} />
        <Route path="/solutions/robot/embodied" element={<EmbodiedRobotSolutions />} />
        <Route path="/solutions/robot/commercial" element={<CommercialRobotSolutions />} />
        <Route path="/solutions/ai-hardware/recorder" element={<AiRecorderSolutions />} />
        <Route path="/solutions/ai-hardware/ai-glasses" element={<AiGlassesSolutions />} />
        <Route path="/solutions/ai-hardware/wearable" element={<WearableSolutions />} />
        <Route path="/solutions/diy-tools/3d-printer" element={<Printer3dSolutions />} />
        <Route path="/solutions/diy-tools/laser" element={<LaserCutterSolutions />} />
        <Route path="/e-bike-industry-solutions" element={<EbikeIndustrySolutions />} />
        <Route path="/solutions/mobility/scooter" element={<ScooterSolutions />} />
        <Route path="/solutions/diy-tools/cnc" element={<DesktopCncSolutions />} />
        <Route path="/solutions/mobility/elderly" element={<ElderlyMobilitySolutions />} />
        <Route path="/solutions/security/bird-feeder" element={<BirdFeederSolutions />} />
        <Route path="/solutions/security/ipc" element={<SecurityCameraSolutions />} />
        <Route path="/solutions/security/hunting-camera" element={<TrailCameraSolutions />} />
        <Route path="/solutions/appliances/water-purifier" element={<WaterPurifierSolutions />} />
        <Route path="/solutions/appliances/ice-maker" element={<IceMakerSolutions />} />
        <Route path="/solutions/fitness/speediance" element={<FitnessGymSolutions />} />
        <Route path="/solutions/pet/smart-life" element={<PetFeederSolutions />} />
        <Route path="/solutions/display/outdoor" element={<OutdoorTvSolutions />} />
        <Route path="/solutions/display/portable-screen" element={<PortableScreenSolutions />} />
        <Route path="/solutions/new-energy/solar-storage" element={<SolarBessSolutions />} />
        <Route path="/solutions/new-energy/home-storage" element={<HomeStorageSolutions />} />
        <Route path="/solutions/new-energy/portable" element={<PortablePowerSolutions />} />
        <Route path="/solutions/new-energy/charging-pile" element={<ChargingPileSolutions />} />
        {industrySolutionPaths
          .filter((path) => !industrySolutionPlaceholderExclude.has(path))
          .map((path) => (
            <Route key={path} path={path} element={<IndustrySolutionPlaceholder />} />
          ))}
        {/* 客服定制 */}
        <Route path="/schemeCustomization" element={<SchemeCustomization />} />

        {/* 兜底重定向 */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </main>
  );
}


